<template>
  <div>
    <head-nav-bar title="房间日志" :fixed="true" />
    <div class="mt-header-nav">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in logData"
          :key="index"
          :value="item.OperationTime"
        >
          <template slot="title">
            <span class="code-name">{{ item.CodeName }}</span>
            <small class="operator"> {{ item.Operator }}</small>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup } from "vant";
// import { ls } from "@/utils/cache.js";
// import { mapState } from "vuex";
import roomApi from "../../api/room.js";
export default {
  name: "roomLog",
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  data() {
    return {
      RoomId: "",
      pageSize: 10,
      logData: [],
    };
  },
  created() {
    this.RoomId = this.$route.query.Id;
    this.getLogList();
  },
  methods: {
    getLogList() {
      roomApi
        .GetRoomLog({
          RoomId: this.RoomId,
          PageIndex: 0,
          PageSize: this.pageSize,
        })
        .then(res => {
          this.logData = res.Data.Datas;
        });
    },
  },
};
</script>
<style lang="less">
.code-name {
  font-size: 16px;
}
.operator {
  font-size: 14px;
  color: #999;
  margin-left: 20px;
}
</style>
